import { PdfStaticTextComponent } from '../../PdfComponent';
import React from 'react';
import { TextInput } from '../../../../components/TextInput';
import { usePdfTemplateContext } from '../../PdfTemplateEditorContext';
import PdfTemplateComponentDefault from '../properties/PdfTemplateComponentDefault';
import PdfTemplateComponentFont from '../properties/PdfTemplateComponentFont';
import PdfTemplateComponentTextAlignment from '../properties/PdfTemplateComponentTextAlignment';
import PdfTemplateComponentBorder from '../properties/PdfTemplateComponentBorder';

interface PdfTemplateTextComponentPropertiesProps {
  component: PdfStaticTextComponent;
}

export default function PdfTemplateTextComponentProperties<T>({ component }: PdfTemplateTextComponentPropertiesProps) {
  const { updateComponent } = usePdfTemplateContext<T>();

  return (
    <div className='grid gap-2'>
      <PdfTemplateComponentDefault component={component} />

      <p className='section-title mt-2'>Style</p>
      <PdfTemplateComponentFont component={component} />
      <PdfTemplateComponentBorder component={component} />

      <p className='section-title mt-2'>Text</p>
      <TextInput
        label={'Text'}
        placeholder={'Enter the desired text'}
        value={component.text}
        onChange={value => updateComponent(component.id, { text: value })}
      />

      <PdfTemplateComponentTextAlignment component={component} />
    </div>
  );
}
